import { Link } from "react-router-dom";
import cardImage2 from "../../assets/images/webp/about-m-larg.webp";
import cardImage1 from "../../assets/images/webp/about-m-sml.webp";
import author from "../../assets/images/webp/testimonials-avatar-7.webp";
import ImageCards from "../common/components/about/ImageCards";
import Hero from "../common/components/Hero";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Cta from "../common/ui/Cta";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";

const MissionVisionMain = () => {
  const missionList = {
    title: "Empowering Businesses for the Future",
    description: [
      "Our mission is simple yet powerful – to empower businesses with the right tools, strategies, and insights that drive sustainable growth and long-term success.",
      "We are committed to helping our clients navigate challenges, embrace opportunities, and achieve measurable results through innovation, dedication, and strategic excellence.",
    ],

    infoHeading:
      "We aim to create meaningful connections between businesses, ideas, and people, fostering growth and transformation across industries.",
    cta: false,
    author: {
      name: "Deepak Sharma",
      role: "Founder & CEO",
      img: author,
    },
    second: {
      title: "",
      description: [
        "We have successfully impacted the lives of over 12,000 clients, helping them grow and thrive.",
      ],
      img1: cardImage1,
      img2: cardImage2,
    },
  };

  return (
    <div className="pb-48">
      <Hero value={5} />
      {missionList && (
        <div className="bg-white pt-10 sm:pt-14 md:pt-20 lg:pt-24 pb-14 sm:pb-16 md:pb-24 lg:pb-28 xl:pb-[140px]">
          <div className="container  mx-auto max-lg:px-3.5 max-md:px-6">
            <div className="flex max-xl:flex-col gap-y-8  gap-x-[57px]">
              <div className="max-lg:max-w-[714px] xl:max-w-[500px] 2xl:max-w-[700px] w-full mx-auto 2xl:ml-0">
                <BlueTag>Our Mission</BlueTag>

                <Heading
                  className={`pt-1 max-xl:mx-auto xl:max-w-[456px]  2xl:max-w-[600px] `}
                >
                  {missionList.title}
                </Heading>
                {missionList.description.map((detail, index) => (
                  <Paragraph
                    key={index}
                    className="pt-3 max-w-[778px] xl:max-w-[500px]  2xl:max-w-[600px]"
                  >
                    {detail}
                  </Paragraph>
                ))}

                {missionList.listBadges && (
                  <div className="inline-flex flex-col gap-y-4 pt-5">
                    {missionList.listBadges.map((obj, index) => (
                      <div
                        key={index}
                        className="inline-flex items-center  gap-x-1.5"
                      >
                        <Icons
                          className="min-w-[18px]"
                          icon="blue-check-mark"
                        />
                        <p className="font-semibold text-sm !leading-130 text-custom-dark-blue">
                          {obj}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
                {missionList.infoHeading && (
                  <h3 className="font-bold !leading-150 text-base md:text-lg text-custom-dark-blue sm:max-w-[768px] xl:max-w-[521px] pt-4 md:pt-6  2xl:max-w-[600px]">
                    {missionList.infoHeading}
                  </h3>
                )}
                {missionList.cta && (
                  <Cta className="max-sm:w-full mt-4 sm:mt-6 md:mt-8">
                    <Link to="/contact-us">Get A Quote</Link>
                  </Cta>
                )}
                {missionList.author && (
                  <div className="flex items-center gap-x-3 mt-3 md:mt-5">
                    <img
                      src={missionList.author.img}
                      alt="author"
                      className="size-11 object-cover rounded-full overflow-clip"
                    />
                    <div>
                      <h3 className=" text-custom-dark-blue text-sm font-semibold !leading-133">
                        {missionList.author.name}
                      </h3>
                      <p className="text-xs !leading-155 font-normal pt-1 text-custom-dark-blue">
                        {missionList.author.role}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className={` flex grow xl:max-w-[583px] 2xl:max-w-[42%] `}>
                <ImageCards detail={missionList.second} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MissionVisionMain;
